// لوحة إدارة مسار — قالب موحّد مع تميز، أقسام حسب الصلاحية الممنوحة (بلا برامج ولا Excel)
import { NavLink, Outlet, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Chip, Skeleton } from "@/v2/components/ui";
import { useMasarAccess } from "@/masar/lib";
import { Compass, LayoutDashboard, FileText, Network, BookOpen, HelpCircle, Award, Users } from "lucide-react";

const SECTIONS = [
  { to: "/masar/admin", label: "اللوحة", icon: LayoutDashboard, area: "view", end: true },
  { to: "/masar/admin/reports", label: "التقارير", icon: FileText, area: "view" },
  { to: "/masar/admin/structure", label: "الهيكل والملفات الوظيفية", icon: Network, area: "matrix" },
  { to: "/masar/admin/matrix", label: "دليل الجدارات", icon: BookOpen, area: "matrix" },
  { to: "/masar/admin/qualifications", label: "الشهادات والتعليم", icon: BookOpen, area: "training" },
  { to: "/masar/admin/certificates", label: "الشهادات والعروض", icon: Award, area: "certs" },
  { to: "/masar/admin/users", label: "الموظفون", icon: Users, area: "view" },
];

export default function MasarAdminShell() {
  const { user } = useAuth();
  const { data: access, isLoading } = useMasarAccess();
  if (isLoading) return <Skeleton className="h-40 w-full" />;
  if (!access?.any) return <Navigate to="/masar" replace />;
  const ok = (a) => (a === "owner" ? access.owner : access.areas?.[a]);
  const items = SECTIONS.filter((s) => ok(s.area) || (s.area === "certs" && access.areas?.training));

  return (
    <div className="space-y-6" data-testid="masar-admin">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-2xl bg-beige/15 text-beige-ink flex items-center justify-center"><Compass size={22} /></div>
          <div>
            <div className="text-lg font-extrabold">{access.supervision ? "متابعة نطاقي في مسار" : "لوحة إدارة مسار"}</div>
            <div className="text-xs text-ink-2">{access.supervision ? `${access.supervision.unit_name} — المؤشرات والموظفون والتقارير ضمن نطاقك` : "المسارات الوظيفية · الجدارات ومتطلبات المسار · الشهادات والعروض · التقارير — من واقع بيانات المنصة"}</div>
          </div>
        </div>
        <Chip tone="gold" className="!py-1.5">{access.role_label || "اطلاع"} — {user?.name}</Chip>
      </div>
      <nav className="flex lg:flex-wrap gap-2 overflow-x-auto lg:overflow-visible pb-1" data-testid="masar-admin-nav">
        {items.map((s) => (
          <NavLink key={s.to} to={s.to} end={s.end} data-testid={`masar-admin-nav-${s.to.split("/").pop()}`}
            className={({ isActive }) => `shrink-0 inline-flex items-center gap-2 px-4 h-10 rounded-full text-xs sm:text-sm font-bold transition-all ${isActive ? "bg-beige text-ink" : "text-ink-2 bg-surface-2 border border-line hover:text-ink"}`}>
            <s.icon size={16} /> {s.label}
          </NavLink>
        ))}
      </nav>
      <Outlet context={access} />
    </div>
  );
}
